import { render, staticRenderFns } from "./PersonProfileAssociatedLocationInfoRow.vue?vue&type=template&id=b27412da&scoped=true&"
import script from "./PersonProfileAssociatedLocationInfoRow.vue?vue&type=script&lang=js&"
export * from "./PersonProfileAssociatedLocationInfoRow.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileAssociatedLocationInfoRow.vue?vue&type=style&index=0&id=b27412da&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27412da",
  null
  
)

export default component.exports